module.exports = __webpack_public_path__ + "e5ed840dae9c0e54b7e8c033fdae7e85.MP3";